export * from "./hotel-reserved-card-footer";
